export const buildInfo = {
  buildVersion: "2.0.1",
  buildDate: 1611751534805,
}
